import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ConfigService } from './config.service';
import { ConvenienceFeeRequest } from '../models/request/ConvenienceFeeRequest';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { PaymentDetails } from '../models/request/PaymentDetails';
import { VerifyTokenResponse } from '../models/request/VerifyTokenResponse';
import { BaseApiService } from '../base-api-service.service';
import { PoeDataService } from '../service/poe-data.service';
import { MetadataResponse } from '../models/request/MetadataResponse';
@Injectable({
  providedIn: 'root'
})
export class PayOnEmailService extends BaseApiService {
  headers: any;
  _wisUrl: any;
  _tenantId: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private PoeDataService: PoeDataService
  ) {
    super();
    this._wisUrl = this.configService.GetWISUrl();
    this.PoeDataService.poeData.subscribe(data => {
      let resultData = data as MetadataResponse;
      this._tenantId = resultData.tenantId;
    });

  }

  VerifyToken(uniqueToken: string) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Billtrust-Auth': uniqueToken
    });
    return this.http.post<VerifyTokenResponse>(`${this._wisUrl}v2/verify-unique-token`,
      {},
      { headers: this.headers, observe: 'response' }
    ).pipe(catchError(this.handleError));
  }

  GetMetaData(uniqueToken: string): Observable<any> {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Billtrust-Auth': uniqueToken,
    });
    return this.http.post(`${this._wisUrl}v2/getmetadata`, null,
      { headers: this.headers, observe: 'response' }
    ).pipe(
      tap((product) => console.log(`Get Metadata`)));
  }

  CalculateConveniencFee(uniqueToken: string, convenienceFeeRequest: ConvenienceFeeRequest) {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Billtrust-Auth': uniqueToken,
    });
    return this.http.post(`${this._wisUrl}v2/tenants/${this._tenantId}/calculate-convenience-fee`, convenienceFeeRequest,
      { headers: this.headers, observe: 'response' }
    ).pipe(
      tap((product) => console.log(`CalculateConveniencFee`)));
  }

  SetMemcache(key: string, value: string, uniqueToken: string) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Billtrust-Auth': uniqueToken
    });
    var memcache = {
      "key": key,
      "value": value
    };
    return this.http.post(`${this._wisUrl}v2/tenants/${this._tenantId}/set-memcache`, memcache,
      { headers: this.headers, observe: 'response' }
    ).pipe(
      tap((product) => console.log(`SetMemcache`)));
  }
  //GetMemcache(key: string, uniqueToken: string): Observable<any> {
  ProcessPayment(uniqueToken: string, paymentDetails: PaymentDetails) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Billtrust-Auth': uniqueToken,
    });
    return this.http.post(`${this._wisUrl}v2/tenants/${this._tenantId}/process-payment`, paymentDetails,
      { headers: this.headers, observe: 'response' }
    );
  }

  GetMemcache(key: string, uniqueToken: string): Observable<any> {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Billtrust-Auth': uniqueToken
    });
    var body = {
      "key": key
    };
    return this.http.post(`${this._wisUrl}v2/tenants/${this._tenantId}/get-memcache`, body,
      { headers: this.headers, observe: 'response' }
    ).pipe(
      tap((product) => console.log(`GetMecache method called`)));
  }
  GetMemcaches(keys: Array<string>, uniqueToken: string): Observable<any> {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Billtrust-Auth': uniqueToken
    });
    var body = {
      "keys": keys
    };
    return this.http.post(`${this._wisUrl}v2/tenants/${this._tenantId}/get-memcache`, body,
      { headers: this.headers, observe: 'response' }
    ).pipe(
      tap((product) => console.log(`GetMecache method called`)));
  }
  RemoveMemcache(key: Array<string>, uniqueToken: string): Observable<any> {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Billtrust-Auth': uniqueToken
    });
    var body = {
      "key": key
    };
    return this.http.post(`${this._wisUrl}v2/tenants/${this._tenantId}/remove-memcache`, body,
      { headers: this.headers, observe: 'response' }
    ).pipe(
      tap((product) => console.log(`RemoveMemcache Method`)));
  }

  PaymentDateValidation(paymentDate: string, accessToken: string) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Billtrust-Auth': accessToken
    });
    var body = {
      "paymentDate": paymentDate
    };
    return this.http.post(`${this._wisUrl}v2/tenants/${this._tenantId}/payment-date-validation`, body,
      { headers: this.headers, observe: 'response' }
    ).pipe(
      tap((product) => console.log(`PaymentDateValidation `)));
  }
}
